import { PlusSquareIcon, ShareIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/ui/dialog';

/**
 * How to install the portal as an app on iOS, where no install prompt exists: from Safari's share sheet. Opened from the user
 * menu ("Install the app") on iPhone and iPad when the portal runs in the browser.
 */
export function InstallAppDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { t } = useTranslation('app');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="sm" data-testid="install-app-dialog">
        <DialogHeader>
          <DialogTitle>{t('install.title')}</DialogTitle>
          <DialogDescription>{t('install.description')}</DialogDescription>
        </DialogHeader>
        <ol className="space-y-3 text-sm text-foreground">
          <li className="flex items-start gap-3">
            <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-brand-soft text-brand-text">
              <ShareIcon className="size-4" aria-hidden />
            </span>
            <span className="pt-1">{t('install.iosShare')}</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-brand-soft text-brand-text">
              <PlusSquareIcon className="size-4" aria-hidden />
            </span>
            <span className="pt-1">{t('install.iosAdd')}</span>
          </li>
        </ol>
        <p className="text-[0.8125rem] text-muted-foreground">{t('install.iosPush')}</p>
      </DialogContent>
    </Dialog>
  );
}
